import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  heading: {
    fontSize: 80,
    fontWeight: 900,
    textAlign: "center",
    verticalAlign: "center",
    alignSelf: "center",
  },
  text: {
    textAlign: "center",
  },
};
